import classes from './ProgressBar.module.scss';

interface ProgressBarProps {
  bgColor: string;
  fillColor: string;
  progress: number;
}

export default function ProgressBar(props: ProgressBarProps) {
  const progress = 350 - props.progress * 3.5;
  const colorStyle = {
    backgroundColor: !Number.isNaN(progress) ? props.fillColor: `#b9b9b9`,
    boxShadow:  `inset -${progress}px 0px 0px ${props.bgColor}`,
  };
  if ( progress === 350) {
    colorStyle.boxShadow = `inset -${progress + 50}px 0px 0px ${props.bgColor}`;
  }
  return <div className={classes.bar} style={colorStyle} />;
}
